// Module
var code = `<div class="column-select-window">

    <div data-bind="visible: inProgress" class="loading_circle"></div>

    <div data-bind="hidden: inProgress" class="column-select-container popup_frame">

        <div class="tw:flex tw:items-center tw:gap-1 tw:pt-1.5 font-default strong">
            <h2 for="unselected_columns" class="tw:w-5/12 tw:py-1.5 txt-center" data-bind="text: translated('Available columns')"></h2>
            <div class="tw:w-1/12"></div>
            <h2 for="selected_columns" class="tw:w-5/12 tw:py-1.5 txt-center" data-bind="text: translated('Selected columns')"></h2>
            <div class="tw:w-1/12"></div>
        </div>

        <div class="tw:flex tw:items-center tw:gap-1">
            <div class="tw:w-5/12">
                <ul class="column-select-list unselected-column-list" id="unselected_columns" data-bind="css: {
                                   expanded: !showUserViews(),
                                   reduced: showUserViews(),
                               },
                               click: clearAvailableColumnSelection,
                               foreach: availableColumns()">
                    <li class="column-item selectable" data-bind="visible: !\$root.chosenColumnIds().includes(id),
                                   click: \$parent.selectAvailableColumn,
                                   event: {
                                        mouseover: \$root.mouseOverAvailableColumn,
                                   },
                                   css: {
                                       selected: \$root.selectedAvailableColumnIds().includes(id),
                                       active: \$root.virtualSelectedAvailableColumnId() == id,
                                       mandatory: \$root.mandatoryColumnIds.includes(id),
                                   },
                                   attr: {'data-column-id': id}">
                        <!-- ko text: label --><!-- /ko -->
                        <!-- ko if: help -->
                            <span class="tooltip_icon">
                                <div class="tooltip_content" data-bind="text: help"></div>
                            </span>
                        <!-- /ko -->
                    </li>
                </ul>
            </div>

            <div class="add-remove-controls tw:w-1/12 txt-center">
                <input type="button" class="add-all icon_button icon_double_right_pointing only_icon_img" data-bind="click: addAllColumns,
                                  attr: {title: translated('Add all')}" value="»"><br>
                <input type="button" class="add-selected icon_button icon_double_right_pointing only_icon_img" data-bind="click: addSelectedColumns,
                                  attr: {title: translated('Add selected')}" value="›"><br>
                <input type="button" class="remove-selected icon_button icon_double_right_pointing only_icon_img" data-bind="click: removeSelectedColumns,
                                  attr: {title: translated('Remove selected')}" value="‹"><br>
                <input type="button" class="remove-all icon_button icon_double_right_pointing only_icon_img" data-bind="click: removeAllColumns,
                                  attr: {title: translated('Remove all')}" value="«">
            </div>

            <div class="tw:w-5/12">
                <ul class="column-select-list selected-column-list" id="selected_columns" data-bind="css: {
                                   expanded: !showUserViews(),
                                   reduced: showUserViews(),
                               },
                               click: clearChosenColumnSelection,
                               foreach: chosenColumnIds">
                    <!-- ko with: \$root.availableColumns().find((c) => c.id == \$data) -->
                    <li class="column-item selectable" data-bind="click: \$root.selectChosenColumn,
                                   event: {
                                        mouseover: \$root.mouseOverChosenColumn,
                                   },
                                   css: {
                                       selected: \$root.selectedChosenColumnIds().includes(id),
                                       active: \$root.virtualSelectedChosenColumnId() == id,
                                       mandatory: \$root.mandatoryColumnIds.includes(id),
                                   },
                                   attr: {'data-column-id': id}">
                        <!-- ko text: label --><!-- /ko -->
                        <!-- ko if: help -->
                            <span class="tooltip_icon">
                                <div class="tooltip_content" data-bind="text: help"></div>
                            </span>
                        <!-- /ko -->
                    </li>
                    <!-- /ko -->
                </ul>
            </div>

            <div class="up-down-controls tw:w-1/12 txt-center">
                <input type="button" class="move-up icon_button icon_arrow_up only_icon_img" data-bind="click: moveSelectedChosenColumnsUp,
                                  attr: {title: translated('Move selected up')}" value="↑"><br>
                <input type="button" class="move-down icon_button icon_arrow_down only_icon_img" data-bind="click: moveSelectedChosenColumnsDown,
                                  attr: {title: translated('Move selected down')}" value="↓">
            </div>

        </div>

        <div class="tw:flex tw:gap-1 tw:pt-2 column-select-options" data-bind="visible: showUserViews">
            <div class="tw:w-5/12">
                <span class="strong italic tw:p-1" data-bind="text: translated('Saved views')"></span>
                <ul class="user-views-list tw:pt-1">
                    <li class="selectable tw:mb-1" data-bind="click: selectDefaultColumns,
                                   css: {selected: selectedUserViewId() == 0},
                                   text: translated('Default view')"></li>
                    <!-- ko foreach: userViews -->
                    <li class="selectable tw:mb-1" data-bind="visible: !\$root.deleteUserViewIds().includes(id),
                                   attr: {'data-user-view-id': id},
                                   css: {selected: \$root.selectedUserViewId() == id},
                                   click: \$root.selectUserView">
                        <span data-bind="text: name || translated('Unnamed previous view')"></span>
                        <span data-bind="visible: name,
                                         click: () => \$root.deleteUserViewIds.push(id)," class="icon_delete icon_button only_icon_img"></span>
                    </li>
                    <!-- /ko -->
                </ul>
            </div>
            <div class="tw:w-1/12"></div>
            <div class="tw:w-5/12">
                <label for="column-select-view-name" class="strong italic tw:p-1.5" data-bind="text: translated('Save as')"></label>
                <div class="tw:pt-1.5">
                    <input type="text" name="user_view_name" class="width_full" id="column-select-view-name" data-bind="textInput: createUserViewName,
                                      attr: {placeholder: translated('Enter a name for this view')}">
                </div>
            </div>
            <div class="tw:w-1/12"></div>
        </div>
        <div class="column-select-controls" data-bind="css: {'options-visible': showUserViews}">
            <div class="error tw:w-p-1.5"></div>
            <div class="tw:flex tw:justify-between tw:gap-2">
                <div class="tw:grow">
                    <a data-bind="click: () => showUserViews(!showUserViews())" class="show-column-select-options clickable">
                        <span data-bind="text: translated('Manage views')"></span>
                        <span data-bind="visible: !showUserViews()" class="icon_button only_icon_img icon_single_up_arrow_bold"></span>
                        <span data-bind="visible: showUserViews()" class="icon_button only_icon_img icon_single_down_arrow_bold"></span>
                    </a>
                </div>
                <!-- ko if: mode == 'export' -->
                <span class="export-file-name">
                    <label for="export_filename" data-bind="text: translated('File name')"></label>:
                    <input type="text" id="export_filename" data-bind="textInput: exportFilename">
                </span>
                <!-- /ko -->
                <div class="tw:flex tw:gap-4">
                    <input type="button" data-bind="value: translated('Cancel'),
                                      click: dialog.close">
                    <input type="button" data-bind="value: translated('Apply'),
                                      visible: mode == 'select',
                                      click: applySelection" class="confirm">
                    <input type="button" data-bind="value: translated('Export'),
                                      visible: mode == 'export',
                                      click: exportSelection" class="confirm">
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;